(() => {
  function initialize() {
    document.querySelectorAll('[data-guide-tools]').forEach((tools) => {
      if (tools.dataset.ready) return;
      tools.dataset.ready = 'true';
      const section = tools.closest('section');
      const navigation = tools.querySelector('[data-guide-navigation]');
      section.querySelectorAll('h2').forEach((heading, index) => {
        if (tools.contains(heading)) return;
        if (!heading.id) heading.id = `guide-${section.closest('[id]').id}-${index}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        navigation.append(link);
      });
      navigation.hidden = !navigation.childElementCount;
    });
    const bar = document.querySelector('[data-mobile-purchase]');
    const purchase = document.querySelector('[data-product-form]');
    if (bar && purchase && !bar.dataset.ready && 'IntersectionObserver' in window) {
      bar.dataset.ready = 'true';
      new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }).observe(purchase);
    }
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
